import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Games',
      component: () => import('../page/index/index'),
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('../page/about/about'),
    },
    {
      path: '/jobs',
      name: 'Jobs',
      component: () => import('../page/jobs/jobs'),
    },
    {
      path: '/jobsDetail',
      name: 'JobsDetail',
      component: () => import('../page/jobs/jobsDetail'),
    },
    {
      path: '/jobsFill',
      name: 'JobsFill',
      component: () => import('../page/jobs/jobsFill'),
    },
    {
      path: '/daily',
      name: 'daily',
      component: () => import('../page/daily/daily')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../page/contact/contact')
    },
    {
      path: '/detail',
      name: 'Detail',
      component: () => import('../page/game/detail'),
    }
    ,
    {
      path: '/inside',
      name: 'inside',
      component: () => import('../page/inside/inside'),
    }
    ,
    {
      path: '/accountdeletion',
      name: 'accountdeletion',
      component: () => import('../page/inside/inside'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js